import script from "./AdminAside.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAside.vue?vue&type=script&setup=true&lang=js"

import "./AdminAside.vue?vue&type=style&index=0&id=6fdebcd2&lang=scss&scoped=true"

import exportComponent from "/Users/mohamedyousef/projects/online_education/projects/web-applications/admin-panel-for-education-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fdebcd2"]])

export default __exports__